export default {
      id: "i-briefcase-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-briefcase",
      toString: function () {
        return this.url;
      }
    }